import { Autocomplete, Box, Chip, TextField, Typography } from '@mui/material'

const labelSx = { display: 'block', fontWeight: 600, fontSize: '0.875rem', color: 'text.primary', mb: 1 } as const
const inputSx = { '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: 'background.paper' } } as const

interface VocabularyPickerProps {
  label: string
  options: string[]
  value: string[]
  onChange: (value: string[]) => void
  getLabel: (option: string) => string
}

export default function VocabularyPicker({ label, options, value, onChange, getLabel }: VocabularyPickerProps) {
  return (
    <Box>
      <Typography component="label" sx={labelSx}>
        {label}
      </Typography>
      <Autocomplete
        multiple
        freeSolo
        forcePopupIcon
        options={options}
        value={value}
        onChange={(_, next) => onChange(next)}
        getOptionLabel={(option) => getLabel(option)}
        renderTags={(tags, getTagProps) => tags.map((option, index) => <Chip label={getLabel(option)} size="small" {...getTagProps({ index })} key={option} />)}
        renderInput={(params) => <TextField {...params} sx={inputSx} />}
      />
    </Box>
  )
}
